import React from 'react';

import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Banner404 from 'common/assets/Banner404';

// TODO - Remove this once DOE Alpha has been fully deprecated.
export default function DOEAlphaScreen404() {
  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        We&apos;re sorry. DOE Alpha has now been decommissioned.
      </Typography>
      <Typography variant="caption">
        Please consider using our current DOE offering within the workflow builder.
      </Typography>
      <Banner404 />
    </Container>
  );
}

const Container = styled('div')({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});
